import 'whatwg-fetch';
import 'formdata-polyfill';
import './utils/removeFallback';
import './utils/elementClosestFallback';
import './modules/personalisation-modal';
import './modules/jumpto-sidebar';
import formModal from './modules/form-modal';
import './modules/webinar';
import './modules/resource-centre';
import './modules/guides-nav';
import './modules/dropdown';
import './modules/bdm';
import '../../deepsea/scripts/modules/swiper';
import './modules/search-investments';
import './modules/olo';
import './modules/ri-calculator';
import './modules/moos';
import './modules/post-progress';
import './modules/tax-nav';
import './modules/segment';
import './modules/utility-nav';
import './modules/client-planning';

formModal();
